import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataTable, DeleteModal, Excel } from "CommonComponent";
import {
  fetchProgramSetups,
  detachProgram,
  getProgramSetupById,
  exportHandler,
} from "actions";
import { Columns, Header, Filter } from "./component";
import "./Program.css";
import DetachModal from "./component/View/component/Header/component/DetachModal";
import AccessRights from "utils/AccessRights";
import { useNavigate, useLocation } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const Programs = () => {
  let location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const programState = useSelector((state) => state.programSetupState);
  const session = useSelector((s) => s.session);

  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  const [showDetachModal, setShowDetachModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [extraFiltersState, setExtraFiltersState] = useState({
    values: {},
  });

  useEffect(() => {
    if (
      session.current_page_permissions &&
      session.current_page_permissions.page_url === location.pathname
    ) {
      dispatch(
        fetchProgramSetups({ ...extraFiltersState.values, object_viewed_id }),
      );
    }
  }, [session.current_page_permissions]);

  useEffect(() => {
    if (programState.redirectToList) {
      dispatch(
        fetchProgramSetups({ ...extraFiltersState.values, object_viewed_id }),
      );
    }
  }, [programState.redirectToList]);

  useEffect(() => {
    if (programState.showSetupForm) {
      navigate("/programs-setup/add");
    }
  }, [programState.showSetupForm]);

  const handleShowDetach = (row) => {
    setSelectedRow(row);
    setShowDetachModal(true);
  };

  const handleShowSetup = (row) => {
    dispatch(getProgramSetupById(row.id, "setup", object_viewed_id));
  };

  const handleCloseDetach = () => {
    setShowDetachModal(false);
    setSelectedRow(null);
  };

  const handleDetach = () => {
    if (selectedRow) {
      dispatch(
        detachProgram(
          selectedRow.id,
          object_viewed_id,
          extraFiltersState.values,
        ),
      );
      handleCloseDetach();
    }
  };

  const filterTable = () => {
    dispatch(
      fetchProgramSetups({ ...extraFiltersState.values, object_viewed_id }),
    );
  };

  const getActions = (row) => (
    <div className="d-flex align-items-center gap-2">
      {AccessRights(
        session.current_page_permissions,
        "delete",
        row.created_by,
      ) &&
        row.is_deleted === "n" && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-detach-${row.id}`}>Detach</Tooltip>}
          >
            <img
              src="/assets/images/detach-btn-icon.svg"
              alt="Detach"
              style={{ cursor: "pointer" }}
              onClick={() => handleShowDetach(row)}
            />
          </OverlayTrigger>
        )}
      {AccessRights(session.current_page_permissions, "edit", row.created_by) &&
        row.is_deleted === "n" && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-setup-${row.id}`}>Setup</Tooltip>}
          >
            <img
              src="/assets/images/setup-btn-icon.svg"
              alt="Setup"
              style={{ cursor: "pointer" }}
              onClick={() => handleShowSetup(row)}
            />
          </OverlayTrigger>
        )}
    </div>
  );

  const handleExport = () => {
    dispatch(
      exportHandler(
        "timesheet/program-setup/export",
        extraFiltersState.values,
        object_viewed_id,
        "timesheet_programs.xlsx",
      ),
    );
  };

  const columns = Columns({ getActions });
  const data = programState.program_setups || [];

  return (
    <div className="wrapper-div">
      <Header extraFilters={extraFiltersState.values} />
      {/* Bread crumb or Filter */}
      <div className="d-flex justify-content-end align-items-center pb-4 px-4 position-sticky top-70 bg-white z-1">
        <div className="d-flex align-items-center gap-3">
          <Excel handleExport={handleExport} />
        </div>
      </div>
      <div>
        <Filter
          onFilter={filterTable}
          extraFiltersState={extraFiltersState}
          setExtraFiltersState={setExtraFiltersState}
        />
        <DataTable
          columns={columns}
          data={data}
          serverSide={false}
          showSearch={false}
          className="table-container"
        />
      </div>

      <DetachModal
        show={showDetachModal}
        handleClose={handleCloseDetach}
        handleDetach={handleDetach}
      />
    </div>
  );
};

export default Programs;
